module.exports = __webpack_public_path__ + "static/img/ys-03.b67b28c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ys-03.jpg
// module id = xyku
// module chunks = 1